<script>
export default {
  name: 'BaseStatusColorPicker',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: String,
    used: Array,
  },
  computed: {
    colors() {
      return [
        ['#434343', '#666666', '#999999', '#B7B7B7', '#CCCCCC'].reverse(),
        ['#DD7E6B', '#CC4125', '#A61C00', '#85200C', '#5B0F00'],
        ['#EA9999', '#E06666', '#CC0000', '#990000', '#700000'],
        ['#F9CB9C', '#F6B26B', '#E69138', '#B45F06', '#783F04'],
        ['#FFE599', '#FFD966', '#F1C232', '#BF9000', '#7F6000'],
        ['#B6D7A8', '#93C47D', '#6AA84F', '#38761D', '#274E13'],
        ['#A2C4C9', '#76A5AF', '#45818E', '#134F5C', '#0C343D'],
        ['#A4C2F4', '#6D9EEB', '#3C78D8', '#1155CC', '#1C4587'],
        ['#9FC5E8', '#6FA8DC', '#3D85C6', '#0B5394', '#073763'],
        ['#B4A7D6', '#8E7CC3', '#674EA7', '#351C75', '#20124D'],
        ['#D5A6BD', '#C27BA0', '#A64D79', '#741B47', '#4C1130'],
      ].reduce((acc, val) => [...acc, ...val], []);
    },
  },
};
</script>

<template lang="pug">
  .base-status-color-picker
    button.color(
      v-for="color in colors"
      :style="`background-color: ${color}`"
      :class="{ active: color === value, used: used.includes(color) }"
      @click="$emit('change', color)"
    ) Статус
</template>

<style scoped lang="scss">
.base-status-color-picker {
  display: grid;
  grid-template-rows: repeat(5, 1fr);
  grid-auto-flow: column;
  gap: 10px;
}

.color {
  display: block;
  padding: 4px 8px;
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  line-height: 1.15;
  border-radius: 4px;
  text-align: center;
  width: 60px;
  border: 2px solid transparent;
  background-clip: padding-box;
  cursor: pointer;

  &.used {
    border: 2px solid red;
    position: relative;
    //overflow: hidden;

    &:before {
      display: block;
      content: '';
      width: 105%;
      height: 2px;
      background: red;
      position: absolute;
      top: 47%;
      left: -3px;
      rotate: 18deg;
    }
  }

  &.active {
    border: 2px solid #52AC2D;
  }
}

@media (max-width: 992px) {
  //.base-status-color-picker {
  //  display: grid;
  //  grid-template-rows: repeat(5, 1fr);
  //  grid-auto-flow: column;
  //  gap: 10px;
  //}

  .base-status-color-picker {
    gap: 5px;
  }

  .color {
    font-size: 0;
    width: auto;
    min-width: 30px;
    aspect-ratio: 1;
    padding: 0;
    overflow: hidden;

    &.used {
      &:before {
        width: 141%;
        top: 47%;
        left: -20%;
        rotate: 45deg;
      }
    }
  }
}

@media (max-width: 576px) {
  .base-status-color-picker {
    grid-auto-flow: row;
    grid-template-rows: auto;
    grid-template-columns: repeat(5, 1fr);
  }
}
</style>
